import { jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useMemo, useState } from "react";
import { useUUID } from "../../../hooks/useUUID.js";
import { Stack } from "../../stack/Stack.js";
import { FieldContextProvider } from "./FieldContext.js";
import { useFieldsetContext } from "./fieldSet/FieldSetContext.js";
const Field = /*#__PURE__*/ forwardRef(({ children, ...stackProps }, ref)=>{
    const fieldSetContext = useFieldsetContext();
    const inputId = useUUID({
        prefix: 'input'
    });
    const labelId = useUUID({
        prefix: 'label'
    });
    const [descriptionIds, setDescriptionIds] = useState([]);
    const [errorMessageIds, setErrorMessageIds] = useState([]);
    const [inputType, setInputType] = useState();
    const [status, setStatus] = useState();
    const [size, setSize] = useState();
    const [disabled, setDisabled] = useState();
    const [readOnly, setReadOnly] = useState();
    const [required, setRequired] = useState();
    const addDescriptionId = useCallback((id)=>setDescriptionIds((ids)=>[
                ...ids,
                id
            ]), []);
    const removeDescriptionId = useCallback((id)=>setDescriptionIds((ids)=>ids.filter((index)=>index !== id)), []);
    const addErrorMessageId = useCallback((id)=>setErrorMessageIds((ids)=>[
                ...ids,
                id
            ]), []);
    const removeErrorMessageId = useCallback((id)=>setErrorMessageIds((ids)=>ids.filter((index)=>index !== id)), []);
    useEffect(()=>{
        fieldSetContext?.onInputStatusChange();
    }, [
        status
    ]);
    const contextValue = useMemo(()=>({
            inputId,
            labelId,
            inputType,
            setInputType,
            status,
            setStatus,
            size,
            setSize,
            disabled,
            setDisabled,
            readOnly,
            setReadOnly,
            required,
            setRequired,
            descriptionIds,
            addDescriptionId,
            removeDescriptionId,
            errorMessageIds,
            addErrorMessageId,
            removeErrorMessageId
        }), [
        inputId,
        labelId,
        inputType,
        status,
        size,
        disabled,
        readOnly,
        required,
        descriptionIds,
        addDescriptionId,
        removeDescriptionId,
        errorMessageIds,
        addErrorMessageId,
        removeErrorMessageId
    ]);
    return /*#__PURE__*/ jsx(FieldContextProvider, {
        value: contextValue,
        children: /*#__PURE__*/ jsx(Stack, {
            gap: "100",
            "data-input-type": inputType,
            ref: ref,
            ...stackProps,
            children: children
        })
    });
});
Field.displayName = 'Field';
export { Field };
